import React from 'react';

const StatusBadge = ({ status }) => {
    const baseClasses = 'inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium';
    const statusClasses = {
        active: 'bg-green-100 text-green-800',
        inactive: 'bg-gray-100 text-gray-800',
        blocked: 'bg-red-100 text-red-800',
        converted: 'bg-green-100 text-green-800',
        'pending': 'bg-yellow-100 text-yellow-800',
    };
    
    const dotClasses = {
        active: 'bg-green-500',
        inactive: 'bg-gray-400',
        blocked: 'bg-red-500',
        converted: 'bg-green-500',
        'pending': 'bg-yellow-400',
    }

    return (
        <span className={`${baseClasses} ${statusClasses[status] || statusClasses['inactive']} capitalize`}>
            <span className={`h-2 w-2 mr-1.5 rounded-full ${dotClasses[status] || dotClasses['inactive']}`}></span>
            {status}
        </span>
    );
};

export default StatusBadge;
